import { normalizeProjectPathForComparison } from "@heydex/shared/path";

export { normalizeProjectPathForComparison };

/** Whether a project is its environment's Scratch project (`ServerConfig.scratchWorkspaceRoot`). */
export function isScratchProject(
  project: { readonly workspaceRoot: string },
  scratchWorkspaceRoot: string | null | undefined,
): boolean {
  if (scratchWorkspaceRoot == null) return false;
  const scratchRoot = normalizeProjectPathForComparison(scratchWorkspaceRoot);
  return (
    scratchRoot.length > 0 &&
    normalizeProjectPathForComparison(project.workspaceRoot) === scratchRoot
  );
}

export * from "./projectCommands.ts";
export * from "./projectEntities.ts";
